
// UserProvider.js
import React, { useState, useEffect, useMemo, useCallback,useRef } from 'react';
import UserContext from './UserContext';
import * as apicall from '../Apicall';

const UserProvider = ({ children }) => {
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);
  const vendorCache = useRef({}); // Using ref instead of state for cache

  const fetchVendorData = useCallback(async (vendorId) => {
    if (!vendorId) {
      setVendor(null);
      setLoading(false);
      return;
    }

    // Check cache first
    if (vendorCache.current[vendorId]) {
      setVendor(vendorCache.current[vendorId]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await apicall.get(`get_vendor_details?id=${vendorId}`);
      if (response.success && Array.isArray(response.data) && response.data.length > 0) {
        const vendorData = response.data[0];
        // Update cache
        vendorCache.current = { ...vendorCache.current, [vendorId]: vendorData };
        setVendor(vendorData);
      } else {
        setVendor(null);
      }
    } catch (err) {
      console.error('Fetch error:', err);
      setVendor(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const vendorId = localStorage.getItem('vendorId');
    fetchVendorData(vendorId);

    const handleStorageChange = (e) => {
      if (e.key === 'vendorId') {
        fetchVendorData(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [fetchVendorData]);

  const refreshVendorData = useCallback(() => {
    const vendorId = localStorage.getItem('vendorId');
    fetchVendorData(vendorId);
  }, [fetchVendorData]);

  const contextValue = useMemo(() => ({
    vendor,
    loading,
    refreshVendorData
  }), [vendor, loading, refreshVendorData]);

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;